export const TRACK_OFF = {
    id: null,
    name: 'Aus (Generic)',
    description: 'Guide arbeitet als allgemeiner Welt-Guide ohne Track-Daten',
};
export const AVAILABLE_TRACKS = [
    TRACK_OFF,
    {
        id: 30,
        name: 'Tscheppaschlucht',
        description: 'Kuratierte POIs/Stories der Tscheppaschlucht (Karawanken)',
    },
];
const STORAGE_KEY = 'gps-tracker-special-track-id';
/**
 * SpecialTrackState — holds the currently-selected special-geo track
 * (or null for off). Persists the selection across page reloads via
 * localStorage so the user doesn't have to re-select every time.
 *
 * Emits 'special-track:changed' on mutation so ControlsView and the
 * GpsTrackerApp controller can react.
 */
export class SpecialTrackState {
    constructor(_bus) {
        this._bus = _bus;
        this._current = TRACK_OFF;
        // Track is NOT restored from localStorage — the UI dropdown is the
        // single source of truth. Previously, persisting caused a ghost bug
        // where Track 30 stayed active across reloads even when the dropdown
        // showed "Aus (Generic World Guide)".
    }
    /** Currently selected track (or TRACK_OFF) */
    get current() {
        return this._current;
    }
    /** True if a track is selected (not TRACK_OFF) */
    get isActive() {
        return this._current.id !== null;
    }
    /** artrack track_id if selected, else null */
    get trackId() {
        return this._current.id;
    }
    /** Set the current track. Pass null to switch off.
     *
     *  Pre-2026-06-09: looked up `trackId` in AVAILABLE_TRACKS and fell
     *  through to TRACK_OFF for unknown IDs. That made sense for the UI
     *  dropdown (only show curated names) but silently broke auto-track-
     *  detect: when `_detectNearbyTrack` reported a track artrack knows
     *  about but our hardcoded list doesn't (e.g. Makerspace=24), this
     *  fell through to OFF — yet the [SYSTEM] Track activation message
     *  had already been sent by setTrack() upstream. Bot received the
     *  hint but no `<artrack id>` tag ever appeared in the gps_update
     *  session block, so it correctly stayed Generic per guide.md rules.
     *
     *  Now: ad-hoc entry for any non-null id artrack reports. Whitelist
     *  in AVAILABLE_TRACKS is for UI rendering only, not for gating
     *  validity.
     */
    setById(trackId) {
        if (trackId === null) {
            this._current = TRACK_OFF;
        }
        else {
            const known = AVAILABLE_TRACKS.find((t) => t.id === trackId);
            this._current = known ?? {
                id: trackId,
                name: `Track ${trackId}`,
                description: `Auto-detected via artrack /tracks/nearby`,
            };
        }
        this._persist();
        this._bus.emit('special-track:changed', { current: this._current });
    }
    /** All known tracks — useful for view rendering */
    get availableTracks() {
        return AVAILABLE_TRACKS;
    }
    _persist() {
        // No-op: track selection is transient per session.
        // The UI dropdown controls the track, not localStorage.
    }
}
//# sourceMappingURL=SpecialTrackState.js.map